import { render, staticRenderFns } from "./HeaderDeDados.vue?vue&type=template&id=3374f333&scoped=true"
import script from "./HeaderDeDados.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderDeDados.vue?vue&type=script&setup=true&lang=js"
import style0 from "./HeaderDeDados.vue?vue&type=style&index=0&id=3374f333&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3374f333",
  null
  
)

export default component.exports